<app-system-message></app-system-message>
<!-- Container for the form with dynamic styling -->
<div [ngClass]="theme.getThemeClass()" class="container-fluid">
    <section [ngClass]="theme.getThemeClass()" class="card bg-light">
        <article class="card-body mx-auto article">
            <h4 class="card-title mt-0 text-center">{{ 'binCreateViewButtonCreateBin' | translate }}</h4>
            <form>
              <!-- BIN NAME -->
              <label class="label-spacer">{{ "binName" | translate }} <span class="requiredStar">*</span></label>
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-dumpster"></i></span>
                <input
                  [(ngModel)]="this.bin.bin_data.bin_name"
                  id="binName"
                  type="text" class="form-control" name="bin_name"
                  value="{{ this.bin.bin_data.bin_name }}"
                  placeholder="{{ 'insertBinName' | translate }}"
                  >
              </div>
              <!-- Select for bin model number -->
              <label class="label-spacer">{{ "binModel" | translate }} <span class="requiredStar">*</span></label>
              <div class="input-group mb-3 firstInput">
                  <span class="input-group-text" id="basic-addon1"><i class="fa fa-hashtag"></i></span>
                  <select
                    [(ngModel)]="this.bin.bin_data.bin_model_id"
                    id="binSelect"
                    class="form-control"
                    name="binSelect"
                    aria-label="Bin_model_number"
                    aria-describedby="basic-addon1"
                    [ngClass]="{ 'has-value': this.bin.bin_data.bin_model_id }"
                    (blur)="this.validationService.validateBinModelNumber(this.bin.bin_data.bin_model_id)"
                    [class.error-border]="this.validationService.validationErrorArray[0] == 'binModelError'"
                    (change)="binModelChange()"
                  >
                    <option value="">{{ 'binSelectOptionSelectBinModel' | translate }}</option>
                    @for (model of binModelOptions; track model.value) {
                      <option [value]="model.value">{{ model.label }}</option>
                    }
                  </select>
              </div>
              
              <!-- Bin Usage -->
              <label class="label-spacer">{{ "adminViewBinUsageNavBar" | translate }} <span class="requiredStar">*</span></label>
              <div class="input-group mb-3">
                  <span class="input-group-text" id="basic-addon1"><i class="fa fa-trash"></i></span>
                  <select
                    class="form-control ng-select"
                    name="binUsage"
                    [(ngModel)]="this.bin.bin_data.bin_usage"
                    aria-label="Bin usage"
                    aria-describedby="basic-addon1"
                    (blur)="this.validationService.validateBinUsage(this.bin.bin_data.bin_usage)"
                    [class.error-border]="this.validationService.validationErrorArray[0] == 'binUsageError'"
                  >
                    <option value="">{{ 'adminViewBinUsageNavBar' | translate }}</option>
                    @for (usage of binUsage; track usage.value) {
                      <option [value]="usage.value">{{ usage.label | translate }}</option>
                    }
                  </select>
              </div>

              <!-- Select for bin market segment -->
              <label class="label-spacer">{{ "marketSegment" | translate }} <span class="requiredStar">*</span></label>
              <div class="input-group mb-3 firstInput">
                  <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-thumbtack"></i></span>
                  <select
                    [(ngModel)]="this.bin.bin_data.market_segment"
                    [ngClass]="{ 'has-value': this.bin.bin_data.market_segment }"
                    id="binSelect"
                    class="form-control"
                    name="binSelect"
                    aria-label="bin_market_segment"
                    aria-describedby="basic-addon1"
                    (blur)="this.validationService.validateBinModelNumber(this.bin.bin_data.bin_model_id)"
                    [class.error-border]="this.validationService.validationErrorArray[0] == 'binModelError'"
                  >
                    <option value="">{{ 'marketSegment' | translate }}</option>
                    @for (seg of marketSegmentOptions; track seg.value) {
                      <option [value]="seg.value">{{ seg.label | translate }}</option>
                    }
                  </select>
              </div>
              <!-- Input field for address with Autocomplete -->
              <label class="label-spacer">{{ "usereditFormLabelAddress" | translate }} <span class="requiredStar">*</span></label>
              <div class="input-group mb-3">
                  <span class="input-group-text" id="basic-addon1"><i class="fas fa-search-location"></i></span>
                  <input id="autocomplete" [(ngModel)]="this.bin.bin_data.bin_address" (keydown)="onInputAddressKeydown($event);"
                  type="text" class="form-control" name="bin_location"
                  placeholder="{{ 'clientcreateFormInputFindAddress' | translate }}"aria-label="Enter a place" aria-describedby="basic-addon1">
              </div>
              <!-- BIN GPS -->
              <label class="label-spacer">{{ 'Latitude' | translate }} </label>
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-location-crosshairs"></i></span>
                <input
                  [(ngModel)]="latitude"
                  id="binName"
                  type="number"
                  class="form-control"
                  name="bin_gps"
                  value="{{ latitude }}"
                  placeholder="{{ 'Latitude' | translate }}"
                >
              </div>
              <label class="label-spacer">{{ 'Longitude' | translate }} </label>
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-location-crosshairs"></i></span>
                <input
                  [(ngModel)]="longitude"
                  id="binName"
                  type="number"
                  class="form-control"
                  name="bin_gps"
                  value="{{ longitude }}"
                  placeholder="{{ 'Longitude' | translate }}"
                >
              </div>

              <!-- Select used to get put an association between bin and client -->
              @if (this.cognitoService.userType === 'muirwood' || this.cognitoService.userType === 'distributor') {
              <label class="label-spacer">{{ "clientName" | translate }}</label>
              }
              @if (this.cognitoService.userType === 'muirwood' || this.cognitoService.userType === 'distributor') {
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fas fa-briefcase"></i></span>
                <select
                  [(ngModel)]="this.bin.bin_data.client_id"
                  class="form-control ng-select"
                  name="client"
                  [ngClass]="{ 'has-value': this.bin.bin_data.client_id }"
                  aria-label="Client Name"
                  aria-describedby="basic-addon1"
                  (change)="selectedClientChange()"
                >
                  <option value="">{{ 'devicecreateSelectClient' | translate }}</option>
                  @for (client of clientOptions; track client.value) {
                    <option [value]="client.value">{{ client.label }}</option>
                  }
                </select>
              </div>
              }
              <!-- Select used to get put an association between bin/client/thing -->
              @if (this.bin.isDeviceArray) {
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-microchip"></i></span>
                <select
                  [(ngModel)]="this.thing_name"
                  class="form-control ng-select"
                  name="client"
                  [ngClass]="{ 'has-value': this.thing_name }"
                  aria-label="Client Name"
                  aria-describedby="basic-addon1"
                  (change)="selectedDeviceChange()"
                >
                  <option value="">{{ 'iotModalViewDeviceName' | translate }}</option>
                  @for (device of deviceOptions; track device.value) {
                    <option [value]="device.value">{{ device.label }}</option>
                  }
                </select>
              </div>
              }
              <!-- Input for the threshold -->
              <label class="label-spacer">{{ "alertThreshold" | translate }} <span class="requiredStar">*</span></label>
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-regular fa-bell"></i></span>
                <input [(ngModel)]="this.bin.bin_data.threshold" type="number"
                class="form-control" name="threshold" aria-label="bin_depth" (change)="thresholdChange()">
              </div>
              <!-- Input for number of bin to create -->
              <label class="label-spacer">{{ "binsNumber" | translate }} <span class="requiredStar">*</span></label>
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-regular fa-square-plus"></i></span>
                <input [(ngModel)]="this.numberToCreate" (ngModelChange)="changeNumberToCreate()" type="number" min="1"
                class="form-control" name="numberToCreate" [disabled]="this.thing_name !== ''"
                placeholder="{{ 'numberToCreate' | translate }}" aria-label="bin_depth">
              </div>
              <!-- Submit button -->
              <nav class="form-group buttonDiv">
                  @if (this.cognitoService.userType === 'muirwood') {
                  <button (click)="returnToAdmin()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-block btnCancel">{{ 'clientcreateFormBtnCancel' | translate }}</button>
                  }
                  @if (this.cognitoService.userType === 'distributor') {
                  <button (click)="processRefererForRedirection()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-block btnCancel">{{ 'clientcreateFormBtnCancel' | translate }}</button>
                  }
                  @if (this.cognitoService.userType === 'client') {
                  <button (click)="returnToClientBinDashboard()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-block btnCancel">{{ 'clientcreateFormBtnCancel' | translate }}</button>
                  }
                  <button [disabled]="this.systemMessageService.buttonBlocked" [ngClass]="theme.getThemeClass()" (click)="onSubmit(); disableButton()" type="button" class="btn btn-block btnCreate">{{ 'binCreateViewButtonCreateBin' | translate }}</button>
              </nav>
            </form>
        </article>
    </section>
</div>
